export default{
  install(Vue) {
    Vue.mixin({
      data(){
        return{
          headBtn:[
            {
              "text":"CONTACT/联系我们",
              "key":"contact"
            },
            {
              "text":"JOIN/品牌加盟",
              "key":"join"
            },
            {
              "text":"PRODUCT/产品中心",
              "key":"prod"
            },
            {
              "text":"ABOUT/公司介绍",
              "key":"company"
            },
            {
              "text":"HOME/首页",
              "key":"Index"
            }
          ]
        }
      },
      methods: {
        onButtonClick: function (e) {
          if (e == "Index") {
            this.$router.push({path: '/'})
          } else if (e == "company") {
            //this.$router.push({path:'/service'})
            //this.$router.push({name: "Index"});
            //window.location.hash = "#服务指南";
            this.$router.push({path: '/company'})
          } else if (e == "prod") {
            //this.$router.push({path:'/plan'})
            //this.$router.push({name: "Index"});
            //window.location.hash = "#产品介绍";
            this.$router.push({path: '/prod'})
          } else if (e == "join") {
            //this.$router.push({path:'/case'})
            //this.$router.push({name: "Index"});
            //window.location.hash = "#发展历程";
            this.$router.push({path: '/join'})
          } else if (e == "contact") {
            this.$router.push({path: '/contact'})
          } else {
            this.$router.push({path: '/'})
          }
        },
        handleCommand(command) {
          if(command=='Index'){
            this.$router.push({path:'/'})
          }
          else if(command=='company'){
            this.$router.push({path:'/company'})
          }
          else if(command=='prod'){
            this.$router.push({path:'/prod'})
          }
          else if(command=='join'){
            this.$router.push({path:'/join'})
          }
          else if(command=='contact'){
            this.$router.push({path:'/contact'})
          }else {
            this.$router.push({path: '/'})
          }
        },
        activeFlag(key){
          console.log( key,this.$route.name,333)
          return key==this.$route.name
        }
      }
    })
  }
}
